<mat-card class="example-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title
      ><input type="text" [(ngModel)]="card.title" placeholder="Title"
    /></mat-card-title>
    <mat-card-subtitle
      >{{ card.status }}:
      {{ card.dueDate | date: 'dd/MM/yyyy' }}
      <input type="date" class="date" [(ngModel)]="card.dueDate" />
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <p>
      <textarea [(ngModel)]="card.description" placeholder="Description"></textarea>
    </p>
  </mat-card-content>
  <mat-card-actions>
    <button mat-button class="action" (click)="saveEvent()">
      {{ card.id ? 'UPDATE' : 'SAVE' }}
    </button>
    <button mat-button class="action" (click)="deleteEvent()">DELETE</button>
  </mat-card-actions>
</mat-card>
